module.exports = __webpack_public_path__ + "static/media/transactionFailedIcon.bae74c36.svg";